// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:base-models` to regenerate.
import DatabaseRecord from "velocious/build/src/database/record/index.js"

/**
 * Attributes accepted when creating or updating ProjectReplicaRegistryEntry records.
 * @typedef {object} ProjectReplicaRegistryEntryWriteAttributes
 * @property {string} [id] - Value for the id attribute.
 * @property {string} [userId] - Value for the userId attribute.
 * @property {string} [projectId] - Value for the projectId attribute.
 * @property {number} [routingEpoch] - Value for the routingEpoch attribute.
 * @property {string} [physicalName] - Value for the physicalName attribute.
 * @property {string} [state] - Value for the state attribute.
 * @property {Date | string | null} [lastOpenedAt] - Value for the lastOpenedAt attribute.
 * @property {Date | string} [createdAt] - Value for the createdAt attribute.
 * @property {Date | string} [updatedAt] - Value for the updatedAt attribute.
 */

/** @augments {DatabaseRecord<ProjectReplicaRegistryEntryWriteAttributes>} */
export default class ProjectReplicaRegistryEntryBase extends DatabaseRecord {
  /** @returns {typeof import("../models/project-replica-registry-entry.js").default} */
  // @ts-ignore - override narrows return type for better IntelliSense in generated model bases
  getModelClass() { return /** @type {typeof import("../models/project-replica-registry-entry.js").default} */ (this.constructor) }

  /** @returns {string} */
  id() { return this.readAttribute("id") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setId(newValue) { return this._setColumnAttribute("id", newValue) }

  /** @returns {boolean} */
  hasId() { return this._hasAttribute(this.id()) }

  /** @returns {string} */
  userId() { return this.readAttribute("userId") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setUserId(newValue) { return this._setColumnAttribute("userId", newValue) }

  /** @returns {boolean} */
  hasUserId() { return this._hasAttribute(this.userId()) }

  /** @returns {string} */
  projectId() { return this.readAttribute("projectId") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setProjectId(newValue) { return this._setColumnAttribute("projectId", newValue) }

  /** @returns {boolean} */
  hasProjectId() { return this._hasAttribute(this.projectId()) }

  /** @returns {number} */
  routingEpoch() { return this.readAttribute("routingEpoch") }

  /**
   * @param {number} newValue
   * @returns {void}
   */
  setRoutingEpoch(newValue) { return this._setColumnAttribute("routingEpoch", newValue) }

  /** @returns {boolean} */
  hasRoutingEpoch() { return this._hasAttribute(this.routingEpoch()) }

  /** @returns {string} */
  physicalName() { return this.readAttribute("physicalName") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setPhysicalName(newValue) { return this._setColumnAttribute("physicalName", newValue) }

  /** @returns {boolean} */
  hasPhysicalName() { return this._hasAttribute(this.physicalName()) }

  /** @returns {string} */
  state() { return this.readAttribute("state") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setState(newValue) { return this._setColumnAttribute("state", newValue) }

  /** @returns {boolean} */
  hasState() { return this._hasAttribute(this.state()) }

  /** @returns {Date | null} */
  lastOpenedAt() { return this.readAttribute("lastOpenedAt") }

  /**
   * @param {Date | string | null} newValue
   * @returns {void}
   */
  setLastOpenedAt(newValue) { return this._setColumnAttribute("lastOpenedAt", newValue) }

  /** @returns {boolean} */
  hasLastOpenedAt() { return this._hasAttribute(this.lastOpenedAt()) }

  /** @returns {Date} */
  createdAt() { return this.readAttribute("createdAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setCreatedAt(newValue) { return this._setColumnAttribute("createdAt", newValue) }

  /** @returns {boolean} */
  hasCreatedAt() { return this._hasAttribute(this.createdAt()) }

  /** @returns {Date} */
  updatedAt() { return this.readAttribute("updatedAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setUpdatedAt(newValue) { return this._setColumnAttribute("updatedAt", newValue) }

  /** @returns {boolean} */
  hasUpdatedAt() { return this._hasAttribute(this.updatedAt()) }
}
